const { parseCurrency } = require('./numbers')

const parseStore = ({ delayFeePerMinute, ...store }) => ({
  ...store,
  delayFeePerMinute: parseCurrency(delayFeePerMinute)
})

export { parseStore }
